import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TablePagination, Box, LinearProgress, Paper, TextField } from '@mui/material';
import CreateUser from './UserAdd';
import ToastMessagge from '../../../../components/utilities/ToastMessage';
import userApi from '../../../../api/userApi';
import userColumns from './userColumns';

function UsersGrid({shouldUpdate  }) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [toastOpen, setToastOpen] = useState(false);
    const [toastMsg, setToastMsg] = useState('');
    const [toastSeverity, setToastSeverity] = useState('success');
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(5);
    const [totalCount, setTotalCount] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchTerm, setSearchTerm] = useState('');
    const [userID, setUserId] = useState(null);
    const [isEditing, setIsEditing] = useState(false);

    const fetchData = async (page, pageSize,searchTerm = '') => {
        setLoading(true);
        try {
            const userData = await userApi.getUsers(page, pageSize, searchTerm);
            setData(userData.results);
            setTotalCount(userData.count);
            setPageSize(pageSize); // Actualiza el estado de pageSize

        } catch (error) {
            console.error("Error al obtener los usuarios:", error);
        }
        setLoading(false);
    };
    const handleUserCreated = (userId, formData) => {
        setToastMsg({ 'Usuario Actualizado Correctamente:': userId });
        setToastSeverity('success');
        setToastOpen(true);
        fetchData(page, pageSize);
    };

    useEffect(() => {
        fetchData(page, pageSize);
    }, [page, pageSize, shouldUpdate]);
    

    const handleEditUser = (userId) => {
        setUserId(userId);
        setIsEditing(true);
    };
    const handleCloseModal = () => {
        setIsEditing(false);
    };

    const handleDeleteUser = async (id) => {
        if (window.confirm("¿Estás seguro de eliminar este usuario?")) {
            try {
                await userApi.deleteUser(id);
                const updatedData = data.filter(user => user.id !== id);
                setData(updatedData);
            } catch (error) {
                console.error("Error al actualizar el usuario:", error);
            }
            }
        };

    const handleToggleActive = async (id, isActive) => {
        try {
            await userApi.toggleUserActive(id, isActive);
            // Actualizar el estado local con el nuevo valor
            const updatedData = data.map(user => 
            user.id === id ? { ...user, is_active: isActive } : user
            );
            setData(updatedData);
        } catch (error) {
            console.error("Error al actualizar el usuario:", error);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        fetchData(newPage, pageSize);
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Vuelve a la primera página al cambiar el tamaño de página
        fetchData(0, parseInt(event.target.value, 10));
    };
    const handleSearchChange = (event) => {
        const searchTerm = event.target.value;
        setSearchTerm(searchTerm);
        setPage(0); // Vuelve a la primera página al cambiar el tamaño de página
        setTimeout(() => {
            fetchData(page, pageSize, searchTerm);
        }, 1000);
    }; 

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <ToastMessagge
                open={toastOpen}
                onClose={() => setToastOpen(false)}
                msg={toastMsg}
                severity={toastSeverity}
            />
            <TextField
                label="Buscar por Usuario o Nombre"
                variant="outlined"
                value={searchTerm}
                onChange={handleSearchChange}
                sx={{ width: '100%' }}
            />
            <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            {loading && (
                <Box
                    sx={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.5)',
                    zIndex: 1,
                    }}
                >
                    <LinearProgress />
                </Box>
                )}
            <TableHead>
                <TableRow>
                    {   userColumns(
                            handleToggleActive,
                            handleEditUser,
                            handleDeleteUser
                        ).map(column => (
                            <TableCell key={column.field}>{column.headerName}</TableCell>
                        ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {data.map((user) => (
                <TableRow key={user.id}>
                    {   userColumns(
                        handleToggleActive,
                        handleEditUser,
                        handleDeleteUser
                    ).map(column => (
                        <TableCell key={column.field}>
                        {column.renderCell
                        ? column.renderCell({ value: user[column.field], id: user.id })
                        : user[column.field]}
                    </TableCell>
                    ))}
                </TableRow>
                ))}
            </TableBody>
            </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
            <Dialog open={isEditing} onClose={handleCloseModal} aria-labelledby="Agregar Usuario" fullWidth maxWidth="md">
                <DialogContent>
                    <CreateUser closeModal={handleCloseModal}   isEditMode={true} onUserCreated={handleUserCreated}  userId={userID} />
                </DialogContent>
            </Dialog>
        </Paper>
    );
}

export default UsersGrid;
